import { createSelector } from "reselect";

// Sharing in every view (share, shared with me, invitations) needs this
export const SHARE_PERMISSION = "CAN_MANAGE_FOLDER_SHARES";

export const selectCanShare = state =>
  !!state.auth?.permissions?.includes(SHARE_PERMISSION);

const selectGranteeFolders = state => state.settings.sharing.grantees.items;

// { [folderId]: number of people the folder is shared with }
export const selectGranteeCountByFolder = createSelector(
  [selectGranteeFolders],
  folders =>
    (folders || []).reduce((counts, folder) => {
      const count = (folder.grantees || []).filter(
        grantee => grantee.role !== "none"
      ).length;

      if (count > 0) {
        counts[folder.id] = count;
      }

      return counts;
    }, {})
);

const selectInvitations = state => state.settings.sharing.invitations;

// Pending invitations the user did not hide with "Yok Say"
export const selectVisibleInvitations = createSelector(
  [selectInvitations],
  invitations => {
    const ignored = invitations?.ignored || [];

    return (invitations?.items || []).filter(
      item => !ignored.includes(`${item.zid}:${item.folder_id}`)
    );
  }
);

const selectShareItems = state => state.settings.sharing.shares?.items;

// Folders shared with the user, by id
export const selectSharesById = createSelector([selectShareItems], shares =>
  (shares || []).reduce((byId, share) => {
    byId[share.id] = share;
    return byId;
  }, {})
);

export const selectSharesByView = createSelector([selectShareItems], shares =>
  (shares || []).reduce((byView, share) => {
    (byView[share.view] = byView[share.view] || []).push(share);
    return byView;
  }, {})
);

export const selectFolderGranteeCount = (state, folderId) =>
  selectGranteeCountByFolder(state)[folderId] || 0;
